









import Vue from 'vue';

export default Vue.extend({
	name: 'CheckboxCard',
	props: {
		disabled: { type: Boolean, required: false },
		headerLocalizationKey: { type: String, required: false },
		checkboxList: { type: Array, required: true },
	},
});
